export const LoginBox = (props, { getState, setState, Auth }) => {
  return {
    render: () => {
      return {
        div: {
          className: 'login-container',
          children: [
            {
              form: {
                className: 'login-form',
                onSubmit: e => {
                  e.preventDefault();
                  const username = getState('login.username', '').trim();
                  const password = getState('login.password', '').trim();
                  if (username.length > 0 && password.length > 0) {
                    Auth.login(username, password);
                  }
                },
                children: [
                  { label: { htmlFor: 'username', text: 'Username' } },
                  {
                    input: {
                      id: 'username',
                      type: 'text',
                      required: true,
                      disabled: () => Auth.isProcessing(),
                      value: () => getState('login.username', ''),
                      onChange: e => setState('login.username', e.target.value),
                    },
                  },
                  { label: { htmlFor: 'password', text: 'Password' } },
                  {
                    input: {
                      id: 'password',
                      type: 'password',
                      required: true,
                      disabled: () => Auth.isProcessing(),
                      value: () => getState('login.password', ''),
                      onChange: e => setState('login.password', e.target.value),
                    },
                  },
                  {
                    span: {
                      id: 'message',
                      hidden: () => !Auth.hasError(),
                      text: () => Auth.lastError(),
                    },
                  },
                  {
                    button: {
                      type: 'submit',
                      disabled: () => Auth.isProcessing(),
                      children: [
                        { span: { hidden: () => Auth.isProcessing(), text: 'Login' } },
                        { span: { className: 'loader', hidden: () => !Auth.isProcessing() } },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        },
      };
    },
  };
};
